/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LimitPaymentOptionsToEnum } from './limit-payment-options-to-enum';
import { BlankEnum } from './blank-enum';

/**
 * @type DeckPitchDetailRequestLimitPaymentOptionsTo
 * @export
 */
export type DeckPitchDetailRequestLimitPaymentOptionsTo = BlankEnum | LimitPaymentOptionsToEnum;
